import { Route } from '@direct-frontend/modules-router';
import { DesignAsync } from '#pages/design';
import {
    FiltersLayoutAsync,
    FiltersPageCategoryAsync,
    FiltersPageCollectionAsync,
    FiltersPageCommonAsync,
} from '#pages/filters';
import { MenuAsync } from '#pages/menu';
import { WindowEditAsync } from '#pages/windowEdit';
import { WindowPageAsync } from '#pages/windows';
import { RedirectWithSearchParams } from '#shared/components/RedirectWithSearchParams';
import { renderWithPermission } from '#shared/lib/managerPermissions';
import {
    designRoute,
    filtersCategoryRoute,
    filtersCollectionAutoRoute,
    filtersCollectionRoute,
    filtersCommonRoute,
    filtersRootRoute,
    menuRoute,
    windowEditRoute,
    windowsRoute,
} from '#shared/lib/routes';

export const editorRoutes = () =>
    renderWithPermission(
        'editor',
        'read',
        <>
            <Route path={menuRoute.route} element={<MenuAsync />} />
            <Route path={designRoute.route} element={<DesignAsync />} />
            <Route path={windowsRoute.route} element={<WindowPageAsync />} />
            <Route path={windowEditRoute.route} element={<WindowEditAsync />} />
            <Route path={filtersRootRoute.route} element={<FiltersLayoutAsync />}>
                <Route path={filtersCommonRoute.route} element={<FiltersPageCommonAsync />} />
                <Route path={filtersCategoryRoute.route} element={<FiltersPageCategoryAsync />} />
                <Route path={filtersCollectionRoute.route} element={<FiltersPageCollectionAsync />} />
                <Route path={filtersCollectionAutoRoute.route} element={<FiltersPageCollectionAsync />} />
                <Route
                    path={filtersRootRoute.route}
                    element={<RedirectWithSearchParams to={filtersCommonRoute.route} replace />}
                />
            </Route>
        </>
    );
